/**
 * INSTAGLOW SKIN CONCERN ASSESSMENT
 * External JS file version for use as a Shopify theme asset.
 *
 * Paired with: instaglow-assessment.css
 * HTML wrapper: the .ig-quiz-wrapper markup from the snippet file.
 *
 * This file auto-initializes on DOMContentLoaded (or immediately if the DOM is
 * already parsed). It finds the most recently added .ig-quiz-wrapper and wires
 * up the quiz logic, results rendering, and email form handler.
 */

(function () {
  function initAssessment() {
    // Ensure viewport meta exists (safety net — Shopify themes already include this)
    if (!document.querySelector('meta[name="viewport"]')) {
      var meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(meta);
    }

    // ==========================================
    // DATA
    // ==========================================
    var quizData = {
      // Real product photo path. Change this to swap the product reveal image.
      // - Local testing: place file in same folder as this JS (e.g. "instaglow-product.jpg")
      // - Shopify Assets: replace with "{{ 'instaglow-product.jpg' | asset_url }}" via the snippet,
      //   or hardcode the full CDN URL here, or set window.IG_PRODUCT_IMAGE before this script loads
      // If the image fails to load, the SVG bottle below is used as a fallback.
      productImage: (typeof window !== 'undefined' && window.IG_PRODUCT_IMAGE) || 'instaglow-product.jpg',

      // Discount code shown after email submission. This must match a real discount
      // created in Shopify Admin > Discounts. Current config matches the "GLOWUP15"
      // code (15% off entire order, one use per customer).
      discount: {
        code: "GLOWUP15",
        label: "Here\u2019s your welcome gift",
        description: "15% off your first InstaGlow order",
        expiresNote: "Apply at checkout. Valid for new customers."
      },

      // Inline SVG illustrations. Swap any of these for an <img> tag or a
      // different SVG to change the visual. Keep the viewBox the same so
      // sizing stays consistent.
      illustrations: {
        q1: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><rect x="15" y="55" width="45" height="12" rx="6" fill="#E8917A"/><circle cx="22" cy="61" r="1.8" fill="#FFF8F5"/><circle cx="30" cy="61" r="1.8" fill="#FFF8F5"/><circle cx="38" cy="61" r="1.8" fill="#FFF8F5"/><circle cx="46" cy="61" r="1.8" fill="#FFF8F5"/><rect x="58" y="50" width="6" height="22" fill="#E8917A"/><rect x="62" y="42" width="42" height="36" rx="6" fill="#FFF0E8" stroke="#E8917A" stroke-width="2.5"/><line x1="68" y1="54" x2="98" y2="54" stroke="#E8917A" stroke-width="1.8" stroke-linecap="round"/><line x1="68" y1="61" x2="98" y2="61" stroke="#E8917A" stroke-width="1.8" stroke-linecap="round"/><line x1="68" y1="68" x2="98" y2="68" stroke="#E8917A" stroke-width="1.8" stroke-linecap="round"/></svg>',
        q2: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><circle cx="60" cy="60" r="48" fill="#FFF0E8" stroke="#E8917A" stroke-width="2.5"/><path d="M28 48 Q43 40 60 48 T92 48" stroke="#E8917A" stroke-width="2.5" fill="none" stroke-linecap="round"/><path d="M26 62 Q43 54 60 62 T94 62" stroke="#E8917A" stroke-width="2.5" fill="none" stroke-linecap="round"/><path d="M28 76 Q43 68 60 76 T92 76" stroke="#E8917A" stroke-width="2.5" fill="none" stroke-linecap="round"/><circle cx="38" cy="55" r="2" fill="#E8917A" opacity="0.6"/><circle cx="72" cy="69" r="2" fill="#E8917A" opacity="0.6"/></svg>',
        q3: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="igTone" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#FFE8DC"/><stop offset="100%" stop-color="#B8795E"/></linearGradient></defs><circle cx="60" cy="60" r="48" fill="url(#igTone)" stroke="#E8917A" stroke-width="2.5"/><path d="M35 95 L85 95" stroke="#E8917A" stroke-width="2.5" stroke-linecap="round"/><path d="M78 91 L85 95 L78 99" stroke="#E8917A" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><text x="35" y="108" font-family="Nunito,sans-serif" font-size="9" font-weight="600" fill="#8A7F7A">lighter</text><text x="62" y="108" font-family="Nunito,sans-serif" font-size="9" font-weight="600" fill="#8A7F7A">darker</text></svg>',
        q4: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><rect x="40" y="35" width="38" height="62" rx="4" fill="#FFF0E8" stroke="#E8917A" stroke-width="2.5"/><rect x="45" y="24" width="28" height="13" rx="2" fill="#E8917A"/><rect x="44" y="52" width="30" height="22" fill="#FFFFFF" stroke="#E8917A" stroke-width="1.5"/><line x1="48" y1="60" x2="70" y2="60" stroke="#E8917A" stroke-width="1.2" stroke-linecap="round"/><line x1="48" y1="66" x2="65" y2="66" stroke="#E8917A" stroke-width="1.2" stroke-linecap="round"/><circle cx="92" cy="42" r="14" fill="#E8D47A" stroke="#4A3F3A" stroke-width="2"/><line x1="92" y1="36" x2="92" y2="44" stroke="#4A3F3A" stroke-width="2.5" stroke-linecap="round"/><circle cx="92" cy="48" r="1.8" fill="#4A3F3A"/></svg>',
        q5: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><path d="M30 35 L45 25 L52 32 Q60 38 68 32 L75 25 L90 35 L96 55 L80 55 L80 98 L40 98 L40 55 L24 55 Z" fill="#FFF0E8" stroke="#E8917A" stroke-width="2.5" stroke-linejoin="round"/><path d="M52 32 Q60 40 68 32" stroke="#E8917A" stroke-width="2.5" fill="none" stroke-linecap="round"/><line x1="50" y1="70" x2="70" y2="70" stroke="#E8917A" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/><line x1="50" y1="78" x2="70" y2="78" stroke="#E8917A" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/></svg>',
        q6: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><ellipse cx="66" cy="48" rx="42" ry="26" fill="#FFF0E8" stroke="#E8917A" stroke-width="2.5"/><circle cx="34" cy="82" r="9" fill="#FFF0E8" stroke="#E8917A" stroke-width="2.5"/><circle cx="20" cy="98" r="5" fill="#FFF0E8" stroke="#E8917A" stroke-width="2.5"/><text x="66" y="58" text-anchor="middle" font-family="Nunito,sans-serif" font-weight="700" font-size="32" fill="#E8917A">?</text></svg>',

        pih: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><circle cx="60" cy="60" r="52" fill="#FFF0E8" stroke="#E8917A" stroke-width="2.5"/><ellipse cx="42" cy="44" rx="9" ry="7" fill="#B8795E" opacity="0.75"/><ellipse cx="70" cy="50" rx="6" ry="5" fill="#B8795E" opacity="0.75"/><ellipse cx="55" cy="68" rx="11" ry="8" fill="#B8795E" opacity="0.75"/><ellipse cx="78" cy="74" rx="6" ry="5" fill="#B8795E" opacity="0.75"/><ellipse cx="40" cy="80" rx="5" ry="4" fill="#B8795E" opacity="0.75"/></svg>',
        bd: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><path d="M60 12 L92 26 L92 58 Q92 88 60 108 Q28 88 28 58 L28 26 Z" fill="#E3F0FA" stroke="#7AB8E8" stroke-width="3" stroke-linejoin="round"/><path d="M48 38 L54 52 L48 62" stroke="#7AB8E8" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M72 42 L66 56 L72 68" stroke="#7AB8E8" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><circle cx="60" cy="62" r="10" fill="#7AB8E8"/><path d="M55 62 L58 66 L65 58" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
        fm: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><circle cx="60" cy="60" r="52" fill="#F0E8FA" stroke="#C4A8E8" stroke-width="2.5"/><line x1="26" y1="44" x2="58" y2="44" stroke="#C4A8E8" stroke-width="3.5" stroke-linecap="round"/><line x1="36" y1="54" x2="68" y2="54" stroke="#C4A8E8" stroke-width="3.5" stroke-linecap="round"/><line x1="26" y1="64" x2="58" y2="64" stroke="#C4A8E8" stroke-width="3.5" stroke-linecap="round"/><line x1="36" y1="74" x2="68" y2="74" stroke="#C4A8E8" stroke-width="3.5" stroke-linecap="round"/><line x1="26" y1="84" x2="58" y2="84" stroke="#C4A8E8" stroke-width="3.5" stroke-linecap="round"/><ellipse cx="82" cy="60" rx="10" ry="22" fill="#8C6AB8" opacity="0.55"/></svg>',
        sr: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><circle cx="60" cy="60" r="52" fill="#FFF8E0" stroke="#E8D47A" stroke-width="2.5"/><ellipse cx="60" cy="34" rx="9" ry="15" fill="#FFFFFF" stroke="#E8D47A" stroke-width="2"/><ellipse cx="60" cy="86" rx="9" ry="15" fill="#FFFFFF" stroke="#E8D47A" stroke-width="2"/><ellipse cx="34" cy="60" rx="15" ry="9" fill="#FFFFFF" stroke="#E8D47A" stroke-width="2"/><ellipse cx="86" cy="60" rx="15" ry="9" fill="#FFFFFF" stroke="#E8D47A" stroke-width="2"/><ellipse cx="42" cy="42" rx="10" ry="8" fill="#FFFFFF" stroke="#E8D47A" stroke-width="2" transform="rotate(-45 42 42)"/><ellipse cx="78" cy="42" rx="10" ry="8" fill="#FFFFFF" stroke="#E8D47A" stroke-width="2" transform="rotate(45 78 42)"/><ellipse cx="42" cy="78" rx="10" ry="8" fill="#FFFFFF" stroke="#E8D47A" stroke-width="2" transform="rotate(45 42 78)"/><ellipse cx="78" cy="78" rx="10" ry="8" fill="#FFFFFF" stroke="#E8D47A" stroke-width="2" transform="rotate(-45 78 78)"/><circle cx="60" cy="60" r="9" fill="#E8D47A"/></svg>',
        dt: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><circle cx="60" cy="60" r="52" fill="#E8F5EC" stroke="#A8D5BA" stroke-width="2.5"/><path d="M60 28 Q44 56 44 72 Q44 88 60 88 Q76 88 76 72 Q76 56 60 28 Z" fill="#A8D5BA" stroke="#6CAB86" stroke-width="2.5" stroke-linejoin="round"/><ellipse cx="54" cy="62" rx="4" ry="8" fill="#FFFFFF" opacity="0.6"/></svg>',

        product: '<svg viewBox="0 0 200 260" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="igBottleShine" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#FFFFFF"/><stop offset="45%" stop-color="#FFF8F5"/><stop offset="100%" stop-color="#F0E6E0"/></linearGradient><linearGradient id="igCapGrad" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stop-color="#F0A896"/><stop offset="100%" stop-color="#E8917A"/></linearGradient></defs><ellipse cx="100" cy="238" rx="58" ry="6" fill="#4A3F3A" opacity="0.08"/><rect x="52" y="62" width="96" height="168" rx="10" fill="url(#igBottleShine)" stroke="#E8917A" stroke-width="3"/><rect x="62" y="28" width="76" height="42" rx="4" fill="url(#igCapGrad)"/><rect x="62" y="28" width="76" height="10" fill="#D97B63"/><rect x="62" y="96" width="76" height="90" fill="#FFF0E8" stroke="#E8917A" stroke-width="1.5"/><text x="100" y="132" text-anchor="middle" font-family="Nunito,sans-serif" font-weight="700" font-size="20" fill="#4A3F3A">InstaGlow</text><line x1="76" y1="142" x2="124" y2="142" stroke="#E8917A" stroke-width="1.5"/><text x="100" y="158" text-anchor="middle" font-family="Nunito,sans-serif" font-weight="400" font-size="9" fill="#8A7F7A" letter-spacing="1.5">UNDERARM</text><text x="100" y="172" text-anchor="middle" font-family="Nunito,sans-serif" font-weight="400" font-size="9" fill="#8A7F7A" letter-spacing="1.5">BRIGHTENING CREAM</text><circle cx="183" cy="70" r="3" fill="#E8917A" opacity="0.6"/><circle cx="17" cy="130" r="4" fill="#A8D5BA" opacity="0.6"/><circle cx="174" cy="190" r="3" fill="#E8917A" opacity="0.6"/><circle cx="22" cy="210" r="3" fill="#A8D5BA" opacity="0.6"/><path d="M178 100 l3 -6 l3 6 l6 3 l-6 3 l-3 6 l-3 -6 l-6 -3 z" fill="#E8917A" opacity="0.5"/></svg>'
      },

      questions: [
        {
          text: "How do you usually remove underarm hair?",
          illustration: "q1",
          options: [
            { text: "Shaving with a razor (regularly)", scores: { PIH: 3, BD: 3, FM: 0, SR: 1, DT: 1 } },
            { text: "Waxing or epilating", scores: { PIH: 2, BD: 2, FM: 0, SR: 2, DT: 0 } },
            { text: "Hair removal cream (depilatory)", scores: { PIH: 2, BD: 3, FM: 0, SR: 3, DT: 1 } },
            { text: "I don\u2019t remove hair / trim only", scores: { PIH: 0, BD: 0, FM: 0, SR: 0, DT: 0 } }
          ]
        },
        {
          text: "How does your underarm skin feel most days?",
          illustration: "q2",
          options: [
            { text: "Smooth and comfortable \u2014 no complaints", scores: { PIH: 0, BD: 0, FM: 0, SR: 0, DT: 0 } },
            { text: "A bit rough or bumpy to the touch", scores: { PIH: 1, BD: 1, FM: 1, SR: 0, DT: 3 } },
            { text: "Itchy, stinging, or easily irritated", scores: { PIH: 0, BD: 3, FM: 0, SR: 3, DT: 1 } },
            { text: "Tight and dry, especially after showering", scores: { PIH: 0, BD: 2, FM: 0, SR: 0, DT: 3 } }
          ]
        },
        {
          text: "Have you noticed any darkening of your underarm skin?",
          illustration: "q3",
          options: [
            { text: "No darkening at all", scores: { PIH: 0, BD: 0, FM: 0, SR: 0, DT: 0 } },
            { text: "Slight shadow, mostly where I shave or wax", scores: { PIH: 3, BD: 1, FM: 0, SR: 0, DT: 0 } },
            { text: "Noticeable darkening where skin rubs together", scores: { PIH: 1, BD: 0, FM: 3, SR: 0, DT: 0 } },
            { text: "Significant, even-toned darkening across the whole area", scores: { PIH: 2, BD: 0, FM: 2, SR: 0, DT: 0 } }
          ]
        },
        {
          text: "How does your skin react when you try a new deodorant or product?",
          illustration: "q4",
          options: [
            { text: "Totally fine \u2014 I can use anything", scores: { PIH: 0, BD: 0, FM: 0, SR: 0, DT: 0 } },
            { text: "Occasionally a little red or itchy for a day", scores: { PIH: 1, BD: 1, FM: 0, SR: 2, DT: 0 } },
            { text: "Often burns, stings, or breaks out", scores: { PIH: 1, BD: 3, FM: 0, SR: 3, DT: 0 } },
            { text: "I\u2019ve mostly stopped trying new products because of reactions", scores: { PIH: 2, BD: 2, FM: 0, SR: 3, DT: 1 } }
          ]
        },
        {
          text: "What kind of clothing do you wear most often?",
          illustration: "q5",
          options: [
            { text: "Loose, breathable fabrics (cotton, linen)", scores: { PIH: 0, BD: 0, FM: 0, SR: 0, DT: 0 } },
            { text: "A mix \u2014 sometimes tight, sometimes loose", scores: { PIH: 0, BD: 0, FM: 2, SR: 0, DT: 0 } },
            { text: "Mostly fitted or synthetic fabrics (polyester, nylon)", scores: { PIH: 0, BD: 1, FM: 3, SR: 1, DT: 1 } },
            { text: "I\u2019m very active and often in workout clothes", scores: { PIH: 0, BD: 1, FM: 3, SR: 1, DT: 1 } }
          ]
        },
        {
          text: "What\u2019s your biggest underarm skin frustration right now?",
          illustration: "q6",
          options: [
            { text: "Dark patches that won\u2019t fade no matter what I try", scores: { PIH: 3, BD: 0, FM: 2, SR: 0, DT: 0 } },
            { text: "Redness, razor bumps, or irritation after grooming", scores: { PIH: 1, BD: 3, FM: 0, SR: 2, DT: 0 } },
            { text: "Rough, uneven texture or flaky skin", scores: { PIH: 0, BD: 1, FM: 0, SR: 0, DT: 3 } },
            { text: "I just want my skin to stop reacting to everything", scores: { PIH: 1, BD: 2, FM: 0, SR: 3, DT: 0 } },
            { text: "Honestly, nothing major \u2014 just curious!", scores: { PIH: 0, BD: 0, FM: 0, SR: 0, DT: 0 } }
          ]
        }
      ],
      concerns: {
        PIH: {
          shortName: "Irritation-Based Darkening",
          headline: "Your skin is holding onto memories of irritation",
          icon: "\u2728",
          illustration: "pih",
          color: "#E8917A",
          explanation: "When underarm skin gets repeatedly irritated \u2014 from shaving, waxing, or harsh products \u2014 it triggers an inflammatory response. Your skin\u2019s defense mechanism is to produce extra melanin at the site of that inflammation. Over time, this creates persistent dark patches that outlast the original irritation. This isn\u2019t a hygiene issue \u2014 it\u2019s your skin\u2019s natural wound-healing response working in overdrive.",
          rootCauses: [
            "Repeated micro-trauma from hair removal",
            "Inflammatory response triggering melanocyte activation",
            "Accumulated melanin deposits in the upper skin layers",
            "Continued irritation preventing existing pigment from fading"
          ],
          ingredients: [
            { name: "Niacinamide (Vitamin B3)", why: "Interrupts the transfer of melanin to skin cells and calms inflammation simultaneously. Well-tolerated even on sensitive skin." },
            { name: "Alpha Arbutin", why: "A gentle melanin-production inhibitor derived from bearberry. Slows new pigment formation without the harshness of hydroquinone." },
            { name: "Vitamin C (Stabilized)", why: "An antioxidant that interferes with melanin synthesis and gradually brightens existing pigmentation." },
            { name: "Licorice Root Extract", why: "Contains glabridin, which inhibits the enzyme that makes melanin and soothes inflamed skin at the same time." }
          ],
          dailyTips: [
            "Switch to a single-blade razor or electric trimmer to reduce micro-cuts",
            "Always shave with a fragrance-free shave gel \u2014 never dry",
            "Apply a niacinamide serum to clean, dry underarms at night",
            "Avoid exfoliating immediately before or after hair removal"
          ]
        },
        BD: {
          shortName: "Compromised Skin Barrier",
          headline: "Your skin\u2019s protective barrier needs rebuilding",
          icon: "\ud83d\udee1\ufe0f",
          illustration: "bd",
          color: "#7AB8E8",
          explanation: "The underarm skin barrier is thinner and more delicate than most body skin. When that barrier gets compromised \u2014 from alcohol-based deodorants, frequent shaving, or chemical irritants \u2014 moisture escapes and irritants penetrate more easily. This creates a cycle: damaged barrier leads to irritation, which leads to more damage. The stinging you feel with new products is your barrier sending an SOS.",
          rootCauses: [
            "Surfactants and alcohol in deodorants stripping natural lipids",
            "Micro-abrasions from shaving removing the protective layer",
            "Disrupted skin microbiome from antibacterial ingredients",
            "Loss of ceramides and natural moisturizing factors"
          ],
          ingredients: [
            { name: "Ceramides", why: "The building blocks of your skin barrier. Topical ceramides physically fill the gaps in a compromised barrier, restoring its seal." },
            { name: "Centella Asiatica (Cica)", why: "Stimulates collagen production in the barrier layer and has strong anti-inflammatory properties. Speeds barrier recovery." },
            { name: "Panthenol (Vitamin B5)", why: "Deeply hydrating humectant that supports barrier repair by promoting lipid synthesis in the skin." },
            { name: "Colloidal Oatmeal", why: "Forms a protective film over the skin while delivering anti-inflammatory compounds. FDA-recognized skin protectant." }
          ],
          dailyTips: [
            "Switch to an alcohol-free, fragrance-free deodorant",
            "Wait at least 10 minutes after shaving before applying any product",
            "Apply a ceramide-based moisturizer to underarms after showering",
            "Give your skin 1\u20132 shave-free days per week to recover"
          ]
        },
        FM: {
          shortName: "Friction-Related Darkening",
          headline: "Repetitive friction is triggering your skin\u2019s pigment response",
          icon: "\ud83c\udf3f",
          illustration: "fm",
          color: "#C4A8E8",
          explanation: "Friction melanosis happens when skin is subjected to repeated mechanical rubbing \u2014 from tight clothing, skin-on-skin contact, or synthetic fabrics. Unlike darkening from chemical irritation, this is caused by physical force. The constant rubbing stimulates your pigment cells in the deeper skin layer, and the melanin they produce gets deposited along the friction lines. This is extremely common and completely unrelated to cleanliness.",
          rootCauses: [
            "Tight-fitting sleeves and synthetic fabrics creating continuous abrasion",
            "Skin-to-skin rubbing during movement, especially exercise",
            "Rough fabric textures irritating the delicate underarm fold",
            "Sweat trapped under non-breathable materials amplifying friction"
          ],
          ingredients: [
            { name: "Niacinamide", why: "Reduces melanin transfer to surface skin cells while strengthening the skin barrier against future friction damage." },
            { name: "Azelaic Acid (up to 10%)", why: "Normalizes melanocyte activity so they produce less excess pigment in response to friction. Also mildly antibacterial." },
            { name: "Squalane", why: "Lightweight, non-comedogenic oil that creates a friction-reducing slip layer on the skin surface. Naturally present in skin." },
            { name: "Allantoin", why: "Promotes cell turnover to gradually clear deposited melanin while soothing irritated tissue." }
          ],
          dailyTips: [
            "Choose cotton or moisture-wicking fabrics for tops and undergarments",
            "Apply a thin layer of squalane oil before getting dressed to reduce friction",
            "Opt for looser fits around the arm and underarm area when possible",
            "After workouts, change out of damp clothing promptly"
          ]
        },
        SR: {
          shortName: "Reactive Skin",
          headline: "Your skin has a heightened alarm system",
          icon: "\ud83c\udf38",
          illustration: "sr",
          color: "#E8D47A",
          explanation: "Sensitive underarm skin has a lower threshold for triggering inflammatory responses. Ingredients that other people tolerate just fine \u2014 fragrances, certain preservatives, aluminum compounds \u2014 cause your skin to mount a disproportionate defensive reaction. This shows up as redness, bumps, stinging, or rashes. It doesn\u2019t mean your skin is weak \u2014 it means your immune response in that area is particularly vigilant.",
          rootCauses: [
            "Higher density of nerve endings responding to irritants",
            "Overactive mast cells releasing histamine at lower thresholds",
            "Compromised barrier allowing allergens to penetrate",
            "Possible contact allergy to fragrances, preservatives, or metals"
          ],
          ingredients: [
            { name: "Aloe Vera Gel", why: "Immediate anti-inflammatory and cooling properties. Contains acemannan which modulates immune response." },
            { name: "Bisabolol (from Chamomile)", why: "Potent anti-irritant that calms redness and inhibits the inflammatory cascade at the cellular level." },
            { name: "Zinc Oxide", why: "Mild astringent and skin protectant that forms a physical barrier while calming reactive skin. Also antimicrobial." },
            { name: "Madecassoside (from Centella)", why: "The most targeted anti-inflammatory compound from Centella Asiatica. Reduces redness and promotes healing." }
          ],
          dailyTips: [
            "Patch-test every new underarm product on your inner forearm for 48 hours first",
            "Use fragrance-free, dye-free formulations exclusively",
            "Avoid deodorants with baking soda \u2014 its high pH disrupts sensitive skin",
            "If razor bumps are chronic, consider switching to an electric trimmer permanently"
          ]
        },
        DT: {
          shortName: "Dry & Rough Skin",
          headline: "Your skin is asking for deeper nourishment and gentle renewal",
          icon: "\ud83d\udca7",
          illustration: "dt",
          color: "#A8D5BA",
          explanation: "Rough, flaky, or uneven underarm texture usually stems from a combination of dehydration and buildup. Dead skin cells accumulate faster when the skin is dry, creating that rough or bumpy feel. Underarm skin doesn\u2019t get the same exfoliation attention as other areas, so the buildup often goes unaddressed. Additionally, antiperspirants that block sweat glands can contribute to a rough, congested texture over time.",
          rootCauses: [
            "Inadequate hydration in the underarm skin layers",
            "Accumulation of dead skin cells from slow natural turnover",
            "Antiperspirant residue congesting the skin surface",
            "Low sebum production in the underarm area compared to face or scalp"
          ],
          ingredients: [
            { name: "Lactic Acid (5\u201310%)", why: "A gentle alpha hydroxy acid that dissolves bonds between dead skin cells. Also a humectant that draws water into skin as it exfoliates." },
            { name: "Urea (5\u201310%)", why: "Softens and dissolves rough, thickened skin. An exceptional humectant at lower concentrations." },
            { name: "Hyaluronic Acid", why: "Holds up to 1000x its weight in water. Plumps dehydrated skin and creates a smoother surface texture." },
            { name: "Shea Butter", why: "Rich emollient that seals moisture in and provides lasting softness. Contains vitamins A and E for nourishment." }
          ],
          dailyTips: [
            "Gently exfoliate underarms 1\u20132 times per week with a lactic acid product (not a physical scrub)",
            "Apply hyaluronic acid serum to damp skin right after showering",
            "Seal with a rich, fragrance-free moisturizer",
            "Thoroughly remove antiperspirant residue with an oil-based cleanser before bed"
          ]
        }
      },
      baselineResult: {
        headline: "Your underarm skin looks healthy!",
        icon: "\u2705",
        explanation: "Based on your answers, your skin isn\u2019t showing strong signs of any particular concern right now. That\u2019s great! Here are some simple habits to keep it that way.",
        tips: [
          "Stick with gentle, fragrance-free products on your underarms",
          "Moisturize after showering to maintain your skin barrier",
          "Replace razors regularly and never shave dry",
          "Choose breathable fabrics when possible to minimize friction"
        ]
      },
      disclaimer: {
        text: "This assessment is educational and informed by published dermatological research. It\u2019s not medical advice \u2014 for persistent or severe skin concerns, we recommend consulting a board-certified dermatologist.",
        sourcesLabel: "Based on research from\u2026",
        sources: [
          { title: "The effect of niacinamide on reducing cutaneous pigmentation and suppression of melanosome transfer", authors: "Hakozaki T, et al.", journal: "British Journal of Dermatology", year: "2002", note: "Foundational study on how niacinamide blocks melanin transfer to surface skin cells." },
          { title: "Efficacy and safety of tranexamic acid in melasma: a meta-analysis and systematic review", authors: "Kim HJ, et al.", journal: "Acta Dermato-Venereologica", year: "2017", note: "Systematic review confirming tranexamic acid as an effective treatment for hyperpigmentation." },
          { title: "Ceramides and skin function", authors: "Coderch L, et al.", journal: "American Journal of Clinical Dermatology", year: "2003", note: "Comprehensive review of how ceramides rebuild the skin barrier and prevent moisture loss." },
          { title: "Centella asiatica in cosmetology", authors: "Bylka W, et al.", journal: "Postepy Dermatologii i Alergologii", year: "2013", note: "Review of Centella Asiatica\u2019s anti-inflammatory and wound-healing properties in skincare." },
          { title: "Hyaluronic acid: A key molecule in skin hydration and aging", authors: "Papakonstantinou E, et al.", journal: "Dermato-Endocrinology", year: "2012", note: "Explores hyaluronic acid\u2019s role in maintaining skin hydration and texture." },
          { title: "Alpha-arbutin as a skin lightening agent: A review of mechanism and clinical efficacy", authors: "Boissy RE, et al.", journal: "Experimental Dermatology", year: "2005", note: "Examines how alpha-arbutin inhibits tyrosinase to reduce melanin production." }
        ]
      },
      product: {
        name: "InstaGlow",
        tagline: "Every ingredient your skin is asking for \u2014 already in one cream.",
        url: "https://www.instaglow.me/products/instaglow-cream",
        btnText: "Learn More About InstaGlow",
        concernMatch: {
          PIH: {
            intro: "Your skin needs ingredients that interrupt excess melanin production and calm the inflammation that triggers it. InstaGlow was formulated with exactly that in mind.",
            highlights: [
              { name: "Tranexamic Acid 3%", role: "One of the most effective brightening actives available. It interrupts the inflammation-to-pigment pathway at its source, preventing new dark patches from forming." },
              { name: "Niacinamide 5%", role: "Blocks the transfer of melanin to your skin\u2019s surface cells. Works on existing pigmentation while preventing new spots." },
              { name: "Alpha Arbutin 0.5%", role: "Gently inhibits tyrosinase \u2014 the enzyme responsible for melanin production \u2014 without the harshness of hydroquinone." },
              { name: "Tetrahexyldecyl Ascorbate 2.5%", role: "A stable, oil-soluble form of Vitamin C that penetrates deeper than regular Vitamin C to brighten from within." }
            ]
          },
          BD: {
            intro: "Your skin needs a barrier-repair formula that restores what\u2019s been stripped away and calms the irritation cycle. InstaGlow contains a full barrier-rebuilding system.",
            highlights: [
              { name: "Triple Ceramide Complex (NP, AP, EOP)", role: "Three types of ceramides that physically rebuild the gaps in your damaged barrier \u2014 restoring its protective seal from the inside out." },
              { name: "Centella Asiatica Extract 2%", role: "A powerful anti-inflammatory that speeds barrier recovery and stimulates collagen production in the protective skin layer." },
              { name: "Panthenol 1%", role: "Vitamin B5 that deeply hydrates while promoting lipid synthesis \u2014 helping your barrier rebuild its own natural defenses." },
              { name: "Lactobacillus Ferment", role: "Supports your skin\u2019s microbiome \u2014 the healthy bacteria that protect against irritation and strengthen barrier function." }
            ]
          },
          FM: {
            intro: "Your skin needs ingredients that reduce friction damage, calm overactive pigment cells, and gradually clear deposited melanin. InstaGlow addresses all three.",
            highlights: [
              { name: "Squalane 2.5%", role: "Creates a lightweight slip layer that reduces skin-on-skin and fabric friction \u2014 addressing the root cause of friction melanosis." },
              { name: "Niacinamide 5%", role: "Reduces melanin transfer to surface cells while strengthening the skin barrier against future friction damage." },
              { name: "Allantoin 0.5%", role: "Promotes gentle cell turnover to gradually clear deposited melanin along friction lines, while soothing irritated tissue." },
              { name: "Undecylenoyl Phenylalanine 0.8%", role: "A targeted peptide that inhibits melanin synthesis specifically in areas of repeated stimulation \u2014 exactly where friction darkening occurs." }
            ]
          },
          SR: {
            intro: "Your skin needs calming, anti-inflammatory ingredients that lower its overactive alarm system \u2014 without introducing new irritants. InstaGlow was designed to be gentle enough for reactive skin.",
            highlights: [
              { name: "Centella Asiatica Extract 2%", role: "Contains madecassoside and asiaticoside \u2014 potent anti-inflammatory compounds that calm redness and quiet the inflammatory cascade." },
              { name: "Beta-Glucan 0.3%", role: "A natural soothing agent that modulates immune response \u2014 helping your skin react proportionately instead of overreacting." },
              { name: "Panthenol 1%", role: "Vitamin B5 with immediate calming properties. Reduces stinging and redness while supporting long-term barrier health." },
              { name: "Lactobacillus Ferment", role: "Restores the skin\u2019s protective microbiome, which helps regulate sensitivity and reduce reactivity to everyday products." }
            ]
          },
          DT: {
            intro: "Your skin needs deep hydration and gentle renewal to dissolve buildup and restore smoothness. InstaGlow combines humectants, emollients, and gentle resurfacing actives.",
            highlights: [
              { name: "Sodium Hyaluronate 1%", role: "A low-molecular-weight form of Hyaluronic Acid that penetrates deep to plump dehydrated skin and create a smoother texture." },
              { name: "Squalane 2.5%", role: "A lightweight emollient that seals in moisture and provides lasting softness \u2014 naturally present in healthy skin." },
              { name: "Bakuchiol 0.5%", role: "A gentle, plant-based alternative to retinol that promotes cell turnover to smooth rough texture \u2014 without irritation." },
              { name: "Triple Ceramide Complex", role: "Locks moisture in by reinforcing the skin barrier, preventing the transepidermal water loss that causes dryness and flaking." }
            ]
          },
          baseline: {
            intro: "Even healthy skin benefits from proactive care. InstaGlow is formulated with ingredients that maintain brightness, hydration, and barrier strength \u2014 keeping your skin at its best.",
            highlights: [
              { name: "Niacinamide 5% + Tranexamic Acid 3%", role: "A brightening duo that maintains an even skin tone and prevents future darkening from everyday irritation." },
              { name: "Triple Ceramide Complex", role: "Keeps your skin barrier strong and resilient, locking in moisture and keeping irritants out." },
              { name: "Centella Asiatica 2%", role: "Proactive anti-inflammatory protection that keeps skin calm through shaving, deodorant use, and daily friction." },
              { name: "Squalane 2.5% + Hyaluronate 1%", role: "A hydration system that keeps underarm skin soft, smooth, and nourished day after day." }
            ]
          }
        }
      }
    };

    // ==========================================
    // INIT (finds the most recently added wrapper so multiple instances work)
    // ==========================================
    var wrappers = document.querySelectorAll('.ig-quiz-wrapper');
    var wrapper = wrappers[wrappers.length - 1];
    if (!wrapper || wrapper.dataset.igInit === '1') return;
    wrapper.dataset.igInit = '1';

    var $ = function (sel) { return wrapper.querySelector(sel); };

    var totalQuestions = quizData.questions.length;
    var currentQuestion = 0;
    var userAnswers = [];

    var introSection = $('.ig-intro');
    var quizSection = $('.ig-quiz');
    var resultsSection = $('.ig-results');
    var emailSection = $('.ig-email-capture');
    var disclaimerSection = $('.ig-disclaimer-footer');
    var questionContainer = $('.ig-question-container');
    var progressFill = $('.ig-progress-fill');
    var progressText = $('.ig-progress-text');
    var progressBar = $('.ig-progress-bar');
    var backBtn = $('.ig-back-btn');
    var startBtn = $('.ig-start-btn');
    var emailForm = $('.ig-email-form');
    var sourcesToggle = $('.ig-sources-toggle');
    var sourcesList = $('.ig-sources-list');

    startBtn.addEventListener('click', startQuiz);
    backBtn.addEventListener('click', prevQuestion);
    emailForm.addEventListener('submit', handleEmailSubmit);
    sourcesToggle.addEventListener('click', toggleSources);
    populateDisclaimer();
    populateDiscount();

    var discountCopyBtn = $('.ig-discount-copy');
    if (discountCopyBtn) discountCopyBtn.addEventListener('click', copyDiscountCode);

    function startQuiz() {
      introSection.classList.add('ig-hidden');
      quizSection.classList.remove('ig-hidden');
      currentQuestion = 0;
      userAnswers = [];
      renderQuestion(0, 'forward');
    }

    function renderQuestion(index, direction) {
      currentQuestion = index;
      var pct = ((index + 1) / totalQuestions) * 100;
      progressFill.style.width = pct + '%';
      progressText.textContent = 'Question ' + (index + 1) + ' of ' + totalQuestions;
      progressBar.setAttribute('aria-valuenow', index + 1);

      if (index > 0) backBtn.classList.remove('ig-hidden');
      else backBtn.classList.add('ig-hidden');

      var q = quizData.questions[index];
      var html = '<div class="ig-question-card ' + (direction === 'forward' ? 'ig-slide-in-right' : 'ig-slide-in-left') + '">';
      if (q.illustration && quizData.illustrations[q.illustration]) {
        html += '<div class="ig-question-illustration">' + quizData.illustrations[q.illustration] + '</div>';
      }
      html += '<h2 class="ig-question-text">' + q.text + '</h2>';
      html += '<div class="ig-options-list">';

      for (var i = 0; i < q.options.length; i++) {
        var selected = userAnswers[index] === i ? ' ig-selected' : '';
        html += '<button type="button" class="ig-option-btn' + selected + '" data-index="' + i + '">';
        html += '<span class="ig-option-letter">' + String.fromCharCode(65 + i) + '</span>';
        html += '<span class="ig-option-text">' + q.options[i].text + '</span>';
        html += '<span class="ig-option-check">';
        html += '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M5.5 9L8 11.5L12.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        html += '</span></button>';
      }
      html += '</div></div>';
      questionContainer.innerHTML = html;

      var buttons = questionContainer.querySelectorAll('.ig-option-btn');
      for (var j = 0; j < buttons.length; j++) {
        buttons[j].addEventListener('click', handleOptionClick);
      }
    }

    function handleOptionClick(e) {
      var btn = e.currentTarget;
      var optionIndex = parseInt(btn.getAttribute('data-index'), 10);
      userAnswers[currentQuestion] = optionIndex;

      var allBtns = questionContainer.querySelectorAll('.ig-option-btn');
      for (var i = 0; i < allBtns.length; i++) allBtns[i].classList.remove('ig-selected');
      btn.classList.add('ig-selected');

      setTimeout(function () {
        if (currentQuestion < totalQuestions - 1) renderQuestion(currentQuestion + 1, 'forward');
        else showResults();
      }, 400);
    }

    function prevQuestion() {
      if (currentQuestion > 0) renderQuestion(currentQuestion - 1, 'backward');
    }

    function calculateScores() {
      var scores = { PIH: 0, BD: 0, FM: 0, SR: 0, DT: 0 };
      for (var i = 0; i < userAnswers.length; i++) {
        if (userAnswers[i] === undefined) continue;
        var weights = quizData.questions[i].options[userAnswers[i]].scores;
        for (var key in weights) scores[key] += weights[key];
      }
      return scores;
    }

    function showResults() {
      var scores = calculateScores();
      var sorted = Object.keys(scores).map(function (k) { return [k, scores[k]]; }).sort(function (a, b) { return b[1] - a[1]; });
      var primary = sorted[0];
      var secondary = null;

      if (primary[1] <= 2) {
        renderBaselineResult();
        return;
      }
      if (sorted.length > 1 && sorted[1][1] >= primary[1] * 0.6) secondary = sorted[1];

      renderConcernResults(primary, secondary, scores);
    }

    function renderConcernResults(primary, secondary, scores) {
      var html = '';
      html += buildConcernCard(primary[0], true);
      if (secondary) {
        html += '<div class="ig-secondary-label">We also noticed...</div>';
        html += buildConcernCard(secondary[0], false);
      }
      html += buildProductCard(primary[0]);

      $('.ig-results-content').innerHTML = html;
      $('.ig-hidden-concerns').value = secondary ? primary[0] + ', ' + secondary[0] : primary[0];
      $('.ig-hidden-scores').value = JSON.stringify(scores);

      quizSection.classList.add('ig-hidden');
      resultsSection.classList.remove('ig-hidden');
      emailSection.classList.remove('ig-hidden');
      triggerAnimations();

      resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function buildConcernCard(concernId, isPrimary) {
      var c = quizData.concerns[concernId];
      var html = '';
      html += '<div class="ig-concern-card ig-anim-item" style="--ig-concern-color: ' + c.color + '">';
      if (c.illustration && quizData.illustrations[c.illustration]) {
        html += '<div class="ig-concern-illustration">' + quizData.illustrations[c.illustration] + '</div>';
      }
      html += '<div class="ig-concern-header">';
      html += '<span class="ig-concern-icon">' + c.icon + '</span>';
      html += '<div class="ig-concern-titles">';
      html += '<span class="ig-concern-badge" style="background: ' + c.color + '20; color: ' + c.color + '">' + c.shortName + '</span>';
      html += '<h3 class="ig-concern-headline">' + c.headline + '</h3>';
      html += '</div></div>';
      html += '<div class="ig-concern-explanation ig-anim-item"><p>' + c.explanation + '</p></div>';

      html += '<div class="ig-concern-section ig-anim-item">';
      html += '<h4>What\u2019s happening under the surface</h4>';
      html += '<ul class="ig-root-causes">';
      for (var i = 0; i < c.rootCauses.length; i++) html += '<li>' + c.rootCauses[i] + '</li>';
      html += '</ul></div>';

      html += '<div class="ig-concern-section ig-anim-item">';
      html += '<h4>Ingredients that can help</h4>';
      html += '<div class="ig-ingredients-grid">';
      for (var j = 0; j < c.ingredients.length; j++) {
        html += '<div class="ig-ingredient-card"><strong>' + c.ingredients[j].name + '</strong><p>' + c.ingredients[j].why + '</p></div>';
      }
      html += '</div></div>';

      html += '<div class="ig-concern-section ig-anim-item">';
      html += '<h4>Daily tips for you</h4>';
      html += '<ol class="ig-daily-tips">';
      for (var k = 0; k < c.dailyTips.length; k++) html += '<li>' + c.dailyTips[k] + '</li>';
      html += '</ol></div></div>';

      return html;
    }

    function renderBaselineResult() {
      var b = quizData.baselineResult;
      var html = '';
      html += '<div class="ig-concern-card ig-baseline ig-anim-item">';
      html += '<div class="ig-concern-header"><span class="ig-concern-icon">' + b.icon + '</span>';
      html += '<div class="ig-concern-titles"><h3 class="ig-concern-headline">' + b.headline + '</h3></div></div>';
      html += '<div class="ig-concern-explanation ig-anim-item"><p>' + b.explanation + '</p></div>';
      html += '<div class="ig-concern-section ig-anim-item"><h4>Keep up the good work with these tips</h4>';
      html += '<ol class="ig-daily-tips">';
      for (var i = 0; i < b.tips.length; i++) html += '<li>' + b.tips[i] + '</li>';
      html += '</ol></div></div>';
      html += buildProductCard('baseline');

      $('.ig-results-content').innerHTML = html;
      $('.ig-hidden-concerns').value = 'Healthy';
      $('.ig-hidden-scores').value = '{}';

      quizSection.classList.add('ig-hidden');
      resultsSection.classList.remove('ig-hidden');
      emailSection.classList.remove('ig-hidden');
      triggerAnimations();
      resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function buildProductCard(concernId) {
      var p = quizData.product;
      var match = p.concernMatch[concernId];
      if (!match) return '';
      var html = '';
      html += '<div class="ig-product-section ig-anim-item">';
      html += '<div class="ig-product-transition"><div class="ig-product-transition-line"></div>';
      html += '<span class="ig-product-transition-text">The good news?</span>';
      html += '<div class="ig-product-transition-line"></div></div>';
      html += '<div class="ig-product-card ig-anim-item">';
      html += '<div class="ig-product-image">';
      if (quizData.productImage) {
        // Real product photo, with SVG fallback if image fails to load
        var fallback = (quizData.illustrations.product || '')
          .replace(/"/g, '&quot;')
          .replace(/</g, '&lt;');
        html += '<img src="' + quizData.productImage + '" alt="InstaGlow Cream" ';
        html += 'data-fallback="' + fallback + '" ';
        html += 'onerror="var p=this.parentNode;p.innerHTML=this.getAttribute(\'data-fallback\').replace(/&lt;/g,\'<\').replace(/&quot;/g,\'\&quot;\');">';
      } else if (quizData.illustrations.product) {
        html += quizData.illustrations.product;
      }
      html += '</div>';
      html += '<h3 class="ig-product-tagline">' + p.tagline + '</h3>';
      html += '<p class="ig-product-intro">' + match.intro + '</p>';
      html += '<div class="ig-product-highlights"><h4>Inside ' + p.name + ', your skin gets:</h4>';
      html += '<div class="ig-product-ingredients-grid">';
      for (var i = 0; i < match.highlights.length; i++) {
        html += '<div class="ig-product-ingredient"><div class="ig-product-ingredient-name">' + match.highlights[i].name + '</div>';
        html += '<div class="ig-product-ingredient-role">' + match.highlights[i].role + '</div></div>';
      }
      html += '</div></div>';
      html += '<a href="' + p.url + '" target="_blank" rel="noopener" class="ig-product-cta">' + p.btnText;
      html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      html += '</a></div></div>';
      return html;
    }

    function triggerAnimations() {
      setTimeout(function () {
        var animItems = resultsSection.querySelectorAll('.ig-anim-item');
        for (var i = 0; i < animItems.length; i++) {
          (function (el, delay) {
            setTimeout(function () { el.classList.add('ig-visible'); }, delay);
          })(animItems[i], i * 150);
        }
        setTimeout(function () {
          emailSection.classList.add('ig-visible');
          disclaimerSection.classList.remove('ig-hidden');
          setTimeout(function () { disclaimerSection.classList.add('ig-visible'); }, 20);
        }, animItems.length * 150 + 200);
      }, 50);
    }

    function populateDisclaimer() {
      var d = quizData.disclaimer;
      if (!d) return;
      $('.ig-disclaimer-text').textContent = d.text;
      $('.ig-sources-label').textContent = d.sourcesLabel;

      var html = '';
      for (var i = 0; i < d.sources.length; i++) {
        var s = d.sources[i];
        html += '<div class="ig-source-item">';
        html += '<div class="ig-source-title">' + s.title + '</div>';
        html += '<div class="ig-source-meta">' + s.authors + ' \u2014 <em>' + s.journal + '</em>, ' + s.year + '</div>';
        if (s.note) html += '<div class="ig-source-note">' + s.note + '</div>';
        html += '</div>';
      }
      sourcesList.innerHTML = html;
    }

    function toggleSources() {
      var isExpanded = sourcesToggle.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        sourcesToggle.setAttribute('aria-expanded', 'false');
        sourcesList.classList.add('ig-hidden');
        sourcesToggle.classList.remove('ig-expanded');
      } else {
        sourcesToggle.setAttribute('aria-expanded', 'true');
        sourcesList.classList.remove('ig-hidden');
        sourcesToggle.classList.add('ig-expanded');
      }
    }

    function populateDiscount() {
      var d = quizData.discount;
      if (!d) return;
      var labelEl = $('.ig-discount-label');
      var codeEl = $('.ig-discount-code');
      var descEl = $('.ig-discount-desc');
      var hiddenEl = $('.ig-hidden-discount');
      if (labelEl) labelEl.textContent = d.label || '';
      if (codeEl) codeEl.textContent = d.code || '';
      if (descEl) descEl.textContent = d.description || '';
      if (hiddenEl) hiddenEl.value = d.code || '';

      // Build Shopify auto-apply discount URL:
      // https://yourstore.com/discount/CODE?redirect=/products/xyz
      // This automatically applies the code and redirects to the product page.
      var shopBtn = $('.ig-shop-now-btn');
      if (shopBtn && quizData.product && quizData.product.url) {
        var shopUrl = quizData.product.url;
        if (d.code) {
          try {
            var u = new URL(quizData.product.url);
            shopUrl = u.origin + '/discount/' + encodeURIComponent(d.code) + '?redirect=' + u.pathname;
          } catch (e) {
            shopUrl = quizData.product.url;
          }
        }
        shopBtn.href = shopUrl;
      }
    }

    function copyDiscountCode() {
      var code = quizData.discount && quizData.discount.code;
      if (!code) return;
      var btn = $('.ig-discount-copy');
      var label = $('.ig-discount-copy-label');
      var originalText = label ? label.textContent : 'Copy';

      function showCopied() {
        if (label) label.textContent = 'Copied!';
        if (btn) btn.classList.add('ig-copied');
        setTimeout(function () {
          if (label) label.textContent = originalText;
          if (btn) btn.classList.remove('ig-copied');
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function () {
          // Fallback for older browsers
          fallbackCopy(code);
          showCopied();
        });
      } else {
        fallbackCopy(code);
        showCopied();
      }
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(textarea);
    }

    function buildPersonalizedSummary(concernIds) {
      // Builds a human-readable summary of the user's results so the email
      // service can drop it straight into the email body. Covers primary +
      // optional secondary concern, with ingredients and daily tips.
      if (!concernIds || !concernIds.length) return '';
      var lines = [];
      for (var i = 0; i < concernIds.length; i++) {
        var c = quizData.concerns[concernIds[i]];
        if (!c) continue;
        var label = i === 0 ? 'YOUR PRIMARY CONCERN' : 'WE ALSO NOTICED';
        lines.push(label + ': ' + c.shortName);
        lines.push(c.headline);
        lines.push('');
        lines.push(c.explanation);
        lines.push('');
        lines.push('INGREDIENTS THAT CAN HELP:');
        for (var j = 0; j < c.ingredients.length; j++) {
          lines.push('- ' + c.ingredients[j].name + ': ' + c.ingredients[j].why);
        }
        lines.push('');
        lines.push('DAILY TIPS:');
        for (var k = 0; k < c.dailyTips.length; k++) {
          lines.push((k + 1) + '. ' + c.dailyTips[k]);
        }
        lines.push('');
        lines.push('---');
        lines.push('');
      }
      return lines.join('\n');
    }

    function handleEmailSubmit(e) {
      e.preventDefault();
      var email = $('.ig-email-input').value;
      if (!email) return;

      var concernsStr = $('.ig-hidden-concerns').value || '';
      var concernIds = concernsStr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var primary = quizData.concerns[concernIds[0]];

      var payload = {
        email: email,
        concerns: concernsStr,
        primary_concern: primary ? primary.shortName : 'General',
        primary_headline: primary ? primary.headline : '',
        scores: $('.ig-hidden-scores').value,
        discount_code: $('.ig-hidden-discount').value,
        discount_description: (quizData.discount && quizData.discount.description) || '',
        product_url: quizData.product.url,
        results_summary: buildPersonalizedSummary(concernIds),
        _subject: 'Your InstaGlow Skin Assessment Results'
      };

      // === EMAIL SENDING ===
      // To actually send the email, set this to your Formspree endpoint.
      // Create a form at https://formspree.io (free tier: 50/month) then paste
      // the endpoint URL below. Configure an "Autoresponder" template in your
      // Formspree dashboard that uses {{primary_concern}}, {{results_summary}},
      // {{discount_code}}, etc. as variables.
      //
      // For custom sender (priya@instaglow.me), you need Formspree Gold ($20/mo)
      // or Klaviyo (free up to 250 contacts) with domain verification.
      var FORMSPREE_ENDPOINT = 'https://formspree.io/f/mreowwyk';

      if (FORMSPREE_ENDPOINT) {
        var fd = new FormData();
        for (var key in payload) {
          if (payload.hasOwnProperty(key)) fd.append(key, payload[key]);
        }
        fetch(FORMSPREE_ENDPOINT, {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' }
        }).catch(function (err) {
          console.error('InstaGlow: email submission failed', err);
        });
      } else {
        // Development fallback — log to console for inspection
        console.log('InstaGlow assessment submission:', payload);
      }

      // Always show the success state (don't block UX on network issues)
      var contentEl = $('.ig-email-card-content');
      if (contentEl) contentEl.classList.add('ig-hidden');
      else {
        emailForm.classList.add('ig-hidden');
        $('.ig-privacy-note').classList.add('ig-hidden');
      }
      $('.ig-email-success').classList.remove('ig-hidden');
    }
  }

  // Run on DOMContentLoaded, or immediately if DOM is already parsed
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAssessment);
  } else {
    initAssessment();
  }
})();
